<template>
	<div class="wireframe" :style="width">
		<div class="wireframe__header">
			<p class="overline">{{ title }}</p>

			<draggable class="inner" :list="value" group="notes">
				<div
					class="list-group-item item relative"
					v-for="(element, index) in value"
					:key="`${titlelc}-${getTime()}-${index}`"
				>
					<h3
						v-if="element.type == 'headline'"
						class="wireframe__headline"
						@click="editDialog(element)"
					>
						<div v-html="element.title"></div>
						<div class="wireframe__overlay">
							<v-btn
								@click="editDialog(element)"
								x-small
								class="white black--text"
								>Edit</v-btn
							>
							<v-btn
								x-small
								@click="removeDialog(index)"
								class="white black--text ml-1"
								>Delete</v-btn
							>
						</div>
					</h3>

					<div class="wireframe__button" v-else-if="element.type == 'button'">
						<div v-html="element.title"></div>
						<div class="wireframe__overlay">
							<v-btn
								@click="editDialog(element)"
								x-small
								class="white black--text"
								>Edit</v-btn
							>
							<v-btn
								x-small
								@click="removeDialog(index)"
								class="white black--text ml-1"
								>Delete</v-btn
							>
						</div>
					</div>
					<div v-else class="wireframe__content">
						<div v-html="element.title"></div>
						<div class="wireframe__overlay">
							<v-btn
								@click="editDialog(element)"
								x-small
								class="white black--text"
								>Edit</v-btn
							>
							<v-btn
								x-small
								@click="removeDialog(index)"
								class="white black--text ml-1"
								>Delete</v-btn
							>
						</div>
					</div>
					<!-- <v-icon
          @click="removeDialog(index)"
          small
          class="black--text ma-1 delete"
          >mdi-close</v-icon
        > -->
				</div>
			</draggable>
		</div>

		<div class="wireframe__icons" v-if="!hideIcons">
			<div>
				<v-btn @click="modalContent" class="ma-1 amber" fab small light>
					<v-icon>mdi-plus</v-icon></v-btn
				>
				Add deliverable
			</div>
			<div>
				<v-btn @click="modalList" class="ma-1" x-small>Rename category</v-btn>
				<v-btn @click="removeList(name)" class="ma-1" x-small
					>Delete category</v-btn
				>
			</div>
		</div>

		<v-dialog v-model="dialog" max-width="800">
			<v-card v-if="dialogMode == 'addContent'">
				<v-card-title>
					<p class="overline">Add deliverable</p>
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="valid" :lazy-validation="lazy">
						<v-textarea
							color="amber"
							v-model="content.text"
							:rows="1"
							:autoGrow="true"
							:hide-details="true"
							class="mb-5"
							placeholder="Enter text..."
							:rules="[(v) => !!v || 'Content is required']"
						/>
						<v-btn @click="addContent" color="amber" light>Save</v-btn>
						<v-btn @click="closeDialog" color="amber" light class="ml-1"
							>Cancel</v-btn
						>
					</v-form>
				</v-card-text>
			</v-card>

			<v-card v-if="dialogMode == 'editContent'">
				<v-card-title>
					<p class="overline">Edit content</p>
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="valid" :lazy-validation="lazy">
						<v-textarea
							color="amber"
							v-model="content.text"
							:rows="1"
							:autoGrow="true"
							:hide-details="true"
							class="mb-5"
							label="Content"
							:rules="[(v) => !!v || 'Content is required']"
						/>
						<v-btn @click="editContent" color="amber" light>Save</v-btn>
						<v-btn @click="closeDialog" color="amber" light class="ml-1"
							>Cancel</v-btn
						>
					</v-form>
				</v-card-text>
			</v-card>

			<v-card v-if="dialogMode == 'editList'">
				<v-card-title>Add heading</v-card-title>

				<v-card-text>
					<v-textarea
						color="amber"
						v-model="newTitle"
						:rows="1"
						:autoGrow="true"
						:hide-details="true"
					/>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="editList" color="amber">Save</v-btn>
				</v-card-actions>
			</v-card>

			<v-card v-if="dialogMode == 'removeContent'">
				<v-card-title>Delete item?</v-card-title>

				<v-card-text>
					<v-btn @click="removeItem" color="amber" light>Yes</v-btn>
					<v-btn @click="closeDialog" color="amber" light class="ml-2"
						>Cancel</v-btn
					>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
// @ is an alias to /src
import draggable from 'vuedraggable';
export default {
	name: 'UserServiceCol',
	data() {
		return {
			newTitle: this.title,
			newNote: '',
			dialog: false,
			dialogMode: '',
			deleteObj: null,
			editItem: null,
			valid: true,
			lazy: false,
			content: {
				type: '',
				text: '',
			},
		};
	},
	props: {
		value: Array,
		title: String,
		name: String,
		width: {
			type: Object,
			defaults: { width: '45%' },
		},
		hideIcons: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		value: {
			handler: function(val) {
				this.$emit('input', val);
			},
			deep: true,
		},
	},
	computed: {
		titlelc() {
			return this.title.toLowerCase();
		},
	},
	components: {
		draggable,
	},
	methods: {
		validate() {
			this.$refs.form.validate();
		},
		reset() {
			this.$refs.form.reset();
		},
		resetValidation() {
			this.$refs.form.resetValidation();
		},

		editList() {
			this.$emit('editList', {
				newTitle: this.newTitle,
				oldTitle: this.title,
				oldName: this.name,
			});
			this.dialog = false;
		},
		modalList() {
			this.dialogMode = 'editList';
			this.dialog = true;
		},
		modalContent() {
			this.content = { type: '', text: '' };
			this.dialogMode = 'addContent';
			this.dialog = true;
		},
		closeDialog() {
			this.dialog = false;
		},
		addContent() {
			if (this.valid) {
				let item = {
					index: this.value.length,
					id: this.value.length,
					title: this.content.text,
					type: 'content',
				};
				this.value.push(item);
				this.content = {
					text: '',
					type: '',
				};
				this.dialog = false;
				this.resetValidation();
				this.$emit('updated');
			}
		},
		editDialog(el) {
			this.dialogMode = 'editContent';
			this.content.type = el.type;
			this.content.text = el.title;
			console.log(el);
			this.editItem = el;
			this.dialog = true;
		},
		editContent() {
			if (this.valid) {
				let pointer = this.value.find((ex) => ex.title == this.editItem.title);
				let index = this.value.indexOf(pointer);

				let item = {
					index: this.editItem.index,
					id: this.editItem.id,
					title: this.content.text,
					type: this.content.type,
				};

				this.$set(this.value, index, item);
				this.dialog = false;
				this.resetValidation();
				this.content = { type: '', text: '' };
				this.$emit('updated');
			}
		},
		// modalHeading() {
		//   this.dialogMode = "addHeading";
		//   this.dialog = true;
		// },
		// addHeading() {
		//   let item = {
		//     index: this.value.length,
		//     id: this.value.length,
		//     title: this.newNote,
		//     type: "headline",
		//   };
		//   this.value.push(item);
		//   this.newNote = "";
		//   this.dialog = false;
		// },
		getTime() {
			return Math.round(new Date().getTime() / 1000);
		},
		removeList(name) {
			this.$emit('removeList', name);
		},
		removeDialog(index) {
			this.dialogMode = 'removeContent';
			this.deleteObj = index;
			console.log(index);
			this.dialog = true;
		},
		removeItem() {
			// let item = this.value.find((ex) => ex.title == this.deleteObj);
			// let index = this.value.indexOf(item);
			this.value.splice(this.deleteObj, 1);
			this.deleteObj = null;
			this.dialog = false;
		},
	},
};
</script>

<style lang="scss">
.delete {
	position: absolute !important;
	right: 0;
	top: 0;
	font-size: 1rem;
}
</style>
